import qs from 'query-string';

const initialState = {
  loading: false,
  error: null,
  results: [],
  linkByPage: [],
  cachedResultsByPage: [],
  totalCount: 0,
  hasMorePagesAvailable: false
};

export default (state = initialState, { type, payload, meta, extra }) => {
  switch (type) {
    case 'LIST_SUBACCOUNTS_PAGINATED_PENDING':
      return { ...state, loading: true, error: null };

    case 'LIST_SUBACCOUNTS_PAGINATED_SUCCESS': {
      const {
        links: { next },
        total_count: totalCount
      } = extra;

      const currentUrlParams = qs.stringify(meta.params);
      const nextUrlParams = next ? qs.extract(next) : null;
      const hasMorePagesAvailable = Boolean(next);
      const linkByPage = [currentUrlParams, nextUrlParams];
      const cachedResultsByPage = [payload];
      return {
        ...state,
        linkByPage,
        totalCount,
        cachedResultsByPage,
        loading: false,
        results: payload,
        hasMorePagesAvailable
      };
    }

    case 'LIST_SUBACCOUNTS_PAGINATED_FAIL':
      return { ...state, loading: false, error: payload };

    case 'GET_SUBACCOUNTS_PAGE_PENDING':
      return { ...state, loading: true, error: null };

    case 'GET_SUBACCOUNTS_PAGE_SUCCESS': {
      const {
        links: { next }
      } = extra;
      const nextUrlParams = next ? qs.extract(next) : null;
      const hasMorePagesAvailable = Boolean(next);
      const { currentPageIndex } = meta;
      const linkByPage = [...state.linkByPage];
      const cachedResultsByPage = [...state.cachedResultsByPage];
      linkByPage[currentPageIndex + 1] = nextUrlParams;
      cachedResultsByPage[currentPageIndex] = payload;
      return {
        ...state,
        linkByPage,
        cachedResultsByPage,
        loading: false,
        results: payload,
        hasMorePagesAvailable
      };
    }

    case 'GET_SUBACCOUNTS_PAGE_FAIL':
      return { ...state, loading: false, error: payload };

    case 'LOAD_SUBACCOUNTS_PAGE_FROM_CACHE': {
      const results = state.cachedResultsByPage[payload];
      return { ...state, results, loading: false };
    }

    case 'RESET_SUBACCOUNTS_PAGINATED':
      return { ...initialState };

    default:
      return state;
  }
};
